import { render, staticRenderFns } from "./ListShiftWorkCongfig.vue?vue&type=template&id=68327890&scoped=true&"
import script from "./ListShiftWorkCongfig.vue?vue&type=script&lang=js&"
export * from "./ListShiftWorkCongfig.vue?vue&type=script&lang=js&"
import style0 from "./ListShiftWorkCongfig.vue?vue&type=style&index=0&id=68327890&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68327890",
  null
  
)

export default component.exports